module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/point-2-74c7cef6f05c206c532f49154f24f314.png";